// extracted by mini-css-extract-plugin
export default {"modal":"ModalWindow-module--modal--def7f","margins":"ModalWindow-module--margins--7e756","close":"ModalWindow-module--close--66a5e","gallery":"ModalWindow-module--gallery--33a9f"};